import api from '@/lib/api'
import { IFaqDetail } from '@/types/Common'

import { API_ROUTE_SERVICES } from '../apiRoutes'

export const getFaq = async (slug: string, locale: string) => {
  try {
    const { data } = await api.get<IFaqDetail[]>(
      `${API_ROUTE_SERVICES}${slug}/faq`,
      {
        headers: {
          'Accept-Language': locale,
        },
      }
    )
    return data
  } catch (err) {
    return Promise.reject(err)
  }
}
